import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IAmountFormMeta {
  // Transaction amounts
  transactionAmount: FormInputMeta;
  transactionCurrencyCode: FormInputMeta;
  settlementAmount: FormInputMeta;
  settlementCurrencyCode: FormInputMeta;
  billingAmount: FormInputMeta;
  billingCurrencyCode: FormInputMeta;
  acquirerSettlementAmount: FormInputMeta;
  acquirerSettlementCurrencyCode: FormInputMeta;
  issuerSettlementAmount: FormInputMeta;
  issuerSettlementCurrencyCode: FormInputMeta;
  // Fees
  transactionFees: FormInputMeta;
  transactionSens: FormInputMeta;
  settlementFees: FormInputMeta;
  settlementSens: FormInputMeta;
  billingFees: FormInputMeta;
  // Original amount
  transactionOriginalAmount: FormInputMeta;  
  originalAmount: FormInputMeta;
  // Currency Conversion Rates
  conversionDate: FormInputMeta;
  settlementConversion: FormInputMeta;
  issuerSettlementConversion: FormInputMeta;  
  acquirerSettlementConversion: FormInputMeta;
  billingSettlementConversion: FormInputMeta;


  schema: any;
}

const AmountFormMeta = {} as IAmountFormMeta;

// Transaction amounts
AmountFormMeta.transactionAmount = {
  name: 'transactionAmount',
  type: 'text',
  label: 'Montant transaction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.transactionCurrencyCode = {
  name: 'transactionCurrencyCode',
  type: 'text',
  label: 'Devise transaction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.settlementAmount = {
  name: 'settlementAmount',
  type: 'text',
  label: 'Montant de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.settlementCurrencyCode = {
  name: 'settlementCurrencyCode',
  type: 'text',
  label: 'Devise règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.billingAmount = {
  name: 'billingAmount',
  type: 'text',
  label: 'Montant de facturation',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.billingCurrencyCode = {
  name: 'billingCurrencyCode',
  type: 'text',
  label: 'Date fin',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.acquirerSettlementAmount = {
  name: 'acquirerSettlementAmount',
  type: 'text',
  label: ' Montant  acquereur de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.acquirerSettlementCurrencyCode = {
  name: 'acquirerSettlementCurrencyCode',
  type: 'text',
  label: 'Devise acquereur de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.issuerSettlementAmount = {
  name: 'issuerSettlementAmount',
  type: 'text',
  label: 'Montant emetteur de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
AmountFormMeta.issuerSettlementCurrencyCode = {
  name: 'issuerSettlementCurrencyCode',
  type: 'text',
  label: 'Devise emetteur de règlement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},

// Fees
AmountFormMeta.transactionFees = {
  name: 'transactionFees',
  type: 'text',
  label: 'Frais transaction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.transactionSens = {
  name: 'transactionSens',
  type: 'text',
  label: 'Sens',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.settlementFees = {
  name: 'settlementFees',
  type: 'text',
  label: 'Frais reglement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.settlementSens = {
  name: 'settlementSens',
  type: 'text',
  label: 'Sens',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.billingFees = {
  name: 'billingFees',
  type: 'text',
  label: 'Frais facturation',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Original amount 
AmountFormMeta.transactionOriginalAmount = {
  name: 'transactionOriginalAmount',
  type: 'text',
  label: 'Montant original de transaction',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.originalAmount = {
  name: 'originalAmount',
  type: 'text',
  label: 'Montant original',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Currency Conversion Rates
AmountFormMeta.conversionDate = {
  name: 'conversionDate',
  type: 'text',
  label: 'Date de conversion',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.settlementConversion = {
  name: 'settlementConversion',
  type: 'text',
  label: 'conversionde reglement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.issuerSettlementConversion = {
  name: 'issuerSettlementConversion',
  type: 'text',
  label: 'emetteur conversion de reglement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.acquirerSettlementConversion = {
  name: 'acquirerSettlementConversion',
  type: 'text',
  label: 'Acquereur conversion de reglement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
AmountFormMeta.billingSettlementConversion = {
  name: 'billingSettlementConversion',
  type: 'text',
  label: 'facturation conversion de reglement',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

AmountFormMeta.schema = yup.object().shape(getValidationSchema(AmountFormMeta));

export default AmountFormMeta;